// extracted by mini-css-extract-plugin
export var assigneeBadge = "_n4-0";
export var assigneeDetails = "_n4-1";
export var assigneeInfo = "_n4-2";
export var dropdownContainer = "_n4-4";
export var dropdownImage = "_n4-5";
export var editAssigneeInfo = "_n4-3";
export var editAssigneeModalContainer = "_n4-6";
export var hidden = "_n4-8";
export var input = "_n4-7";